/**
 * What a tap on the phone bar's + makes (SPEC §8.4). The screen showing says: a card on Home or a
 * card tab, an item for the day on Days, a note on Notes, a page on Pages, an item inside the one
 * open. Anywhere else, an item for your usual place (the Inbox unless you've changed it).
 */
import { useEffect, useRef } from 'react'
import { openSheet } from './router'

let current: { run: () => void } | null = null

/** This screen's + (while it shows). */
export function useAddButton(run: () => void) {
  const latest = useRef(run)
  useEffect(() => {
    latest.current = run
  })
  useEffect(() => {
    const mine = { run: () => latest.current() }
    current = mine
    return () => {
      if (current === mine) current = null
    }
  }, [])
}

export function runAddButton() {
  if (current) current.run()
  else openSheet('add', { mode: 'item' })
}
